import { useQuery } from '@tanstack/react-query'
import api from '../../api'

const useSingleMongoDB = (mongoDBID: string) =>
	useQuery({
		queryKey: ['mongodb', mongoDBID],
		queryFn: () => api.mongodb.getSingleMongoDB(mongoDBID),
		select(data) {
			const [record] = data.body
			if (!record || record.mongoDBID !== mongoDBID) {
				throw new Error('MongoDB request was not found.')
			}
			return record
		},
		enabled: Boolean(mongoDBID),
		retry: false,
		refetchOnWindowFocus: false
	})

export default useSingleMongoDB
